import React from 'react';
import { Card, CardBody, Button } from '@nextui-org/react';
import { useLocation } from 'wouter';
import { Icon } from '@iconify/react';

const AccessDeniedPage: React.FC = () => {
  const [_, setLocation] = useLocation();

  return (
    <div className='flex items-center justify-center h-[80vh]'>
      <Card className='max-w-md w-full'>
        <CardBody className='flex flex-col items-center p-8 text-center space-y-6'>
          <div className='text-danger p-4 rounded-full bg-danger-50'>
            <Icon icon='tabler:lock' width={40} />
          </div>

          {/* design-ignore: pantalla de acceso denegado */}
          <h1 className='text-2xl font-bold'>Acceso Denegado</h1>

          <p className='text-default-500'>
            No tienes permiso para acceder a esta página. Si crees que deberías
            tener acceso, contacta a tu administrador.
          </p>

          <Button
            color='primary'
            onClick={() => setLocation('/daily-market')}
            className='mt-4'
          >
            Volver al Inicio
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};

export default AccessDeniedPage;
